// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"63b5bbbc","186":"b438ac0c","453":"15ecd41f","531":"72d758c2","625":"7601bc64","649":"64115b1a","652":"5fecc75c","674":"db22ae3d","900":"d8a3d064"}[chunkId] + ".chunk.js";
};